import cn from 'classnames';
import { AddedItems } from './AddedItems/AddedItems';
import styled from 'styled-components';
import { Container, desktopStyle } from './Style';
import { Form } from 'connex-cds';
import { MaterialSummaryDesktop } from './MaterialSummary/MaterialSummaryDesktop';
import BatchResults from './BatchResults/BatchResults';
import DeliveryInformation from './DeliveryInformation/DeliveryInformation';
import React from 'react';

const Styled = styled.div`
  &.dot-workflow-desktop {
    ${desktopStyle}
  }
`;

export const DotWorkflowDesktop = ({ data, ticket, order, filtereData }) => {
  const { values } = Form.useFormContext();

  return (
    <Styled className={cn('dot-workflow-desktop')}>
      <div className="batch-information">
        <MaterialSummaryDesktop source={filtereData?.consumption} results={data?.testsResult} />
        <Container>
          <div style={{ width: '50%' }}>
            <BatchResults source={filtereData?.batch} results={data?.testsResult} />
          </div>
          <div style={{ width: '50%' }}>
            <DeliveryInformation ticket={ticket ?? {}} order={order ?? {}} />
          </div>
        </Container>
      </div>
      <div className="added-items">
        <AddedItems productCompliance={values?.productCompliance ?? {}} results={data?.testsResult} />
      </div>
    </Styled>
  );
};
